import React, { useState } from 'react';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Button, Col, FormGroup, Input, InputGroup, Row } from 'reactstrap';
// import { MenuCategoryDropdown } from '../Component/MenuCategoryDropdown';
// import { MenuItemDropdown } from '../Component/MenuItemDropdown';
import { DiscountDataTable } from '../Component/DiscountDatatable';
import { AddDiscount } from '../Component/AddDiscount';

export const DiscountManagement = () => {
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [selectedItem, setSelectedItem] = useState('');
  const [isAddDiscountOpen, setIsAddDiscountOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // State to force re-render
  const [searchQuery, setSearchQuery] = useState(''); // State for search query

//   const handleItemChange = (e) => {
//     setSelectedItem(e.target.value);
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//   };

  const toggleAddDiscountPopup = () => {
    setIsAddDiscountOpen((prev) => !prev);
  };

  const refreshDiscounts = () => {
    setRefreshKey((prev) => prev + 1); // Update the key to force re-render
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value); // Update the search query
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Discount Offer List" pageTitle="Discount Offer" />
      </div>
      <Row className="mb-3 d-flex justify-content-between">
        <Col md={4} xs={6} className="px-xs-1">
          <InputGroup>
            <Input
              placeholder="Search by title"
              value={searchQuery}
              onChange={handleSearchChange} // Handle search input change
            />
          </InputGroup>
        </Col>

        <Col md={2} xs={6} className='d-flex justify-content-end'>
          <Button className='package-button px-1 px-sm-2' onClick={toggleAddDiscountPopup}>
            Add Discount
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <DiscountDataTable
            refreshDiscounts={refreshDiscounts}
            key={refreshKey}
            searchQuery={searchQuery} // Pass the search query to the table
          />
        </Col>
      </Row>
      <AddDiscount
        isOpen={isAddDiscountOpen}
        toggle={toggleAddDiscountPopup}
        refreshDiscounts={refreshDiscounts}
      />
    </div>
  );
};